<div class="sound-buttons flex items-stretch">
  <button
    type="button"
    class="sound-toggle"
    data-sfx="none"
    [class.is-muted]="muted()"
    [attr.tabindex]="tabIndex()"
    [attr.aria-pressed]="muted()"
    [attr.aria-label]="muted() ? 'Unmute sound' : 'Mute sound'"
    [attr.title]="muted() ? 'Unmute (M)' : 'Mute (M)'"
    (click)="toggleMute()"
  >
    <svg
      class="sound-icon"
      viewBox="0 0 16 16"
      width="16"
      height="16"
      shape-rendering="crispEdges"
      aria-hidden="true"
    >
      <rect x="1" y="6" width="3" height="4" />
      <rect x="4" y="5" width="1" height="6" />
      <rect x="5" y="4" width="1" height="8" />
      <rect x="6" y="3" width="1" height="10" />
      @if (muted()) {
      <rect x="9" y="5" width="1" height="1" />
      <rect x="10" y="6" width="1" height="1" />
      <rect x="11" y="7" width="2" height="2" />
      <rect x="13" y="9" width="1" height="1" />
      <rect x="14" y="10" width="1" height="1" />
      <rect x="14" y="5" width="1" height="1" />
      <rect x="13" y="6" width="1" height="1" />
      <rect x="10" y="9" width="1" height="1" />
      <rect x="9" y="10" width="1" height="1" />
      } @else {
      <rect x="9" y="6" width="1" height="4" />
      <rect x="11" y="4" width="1" height="2" />
      <rect x="12" y="6" width="1" height="4" />
      <rect x="11" y="10" width="1" height="2" />
      }
    </svg>
  </button>
  <button
    type="button"
    class="sound-expand"
    [attr.tabindex]="tabIndex()"
    [attr.aria-expanded]="open()"
    aria-controls="snk-sound-panel"
    aria-label="Volume settings"
    title="Volume"
    (click)="togglePanel()"
  >
    <span aria-hidden="true">{{ open() ? '▲' : '▼' }}</span>
  </button>
</div>

@if (open()) {
<div
  id="snk-sound-panel"
  class="sound-panel mt-2 flex flex-col gap-3 p-4"
  role="group"
  aria-label="Volume"
>
  @for (channel of channels; track channel.key) {
  <label class="flex items-center gap-3">
    <span class="sound-label w-16 shrink-0">{{ channel.label }}</span>
    <input
      type="range"
      class="sound-range"
      min="0"
      max="100"
      step="5"
      [attr.tabindex]="tabIndex()"
      [value]="percents()[channel.key]"
      [attr.aria-valuetext]="percents()[channel.key] + '%'"
      (input)="onVolumeInput(channel.key, $event)"
      (change)="onVolumeCommit(channel.key)"
    />
    <span class="sound-value w-10 shrink-0 text-right"
      >{{ percents()[channel.key] }}%</span
    >
  </label>
  }
  <label class="sound-mute flex items-center gap-2">
    <input
      type="checkbox"
      [attr.tabindex]="tabIndex()"
      [checked]="muted()"
      (change)="onMuteChange($event)"
    />
    <span>MUTE ALL</span>
    <span class="sound-hint ml-auto">M</span>
  </label>
  @if (!inRoom()) {
  <a class="sound-board-link" routerLink="/sounds" (click)="open.set(false)"
    >ALL SOUNDS ›</a
  >
  }
</div>
}
